import React, { useState, useEffect } from 'react';

const PromoBar = () => {
  const [countdown, setCountdown] = useState({
    days: 6,
    hours: 2,
    minutes: 23,
    seconds: 51
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(prev => {
        let { days, hours, minutes, seconds } = prev;

        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 23;
          days--;
        }
        if (days < 0) {
          clearInterval(interval);
          return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (time) => (time < 10 ? `0${time}` : time);

  return (
    <>
      {/* PromoBar Mobile */}
      <div className="sm:hidden bg-green-700 text-white px-4 py-2 text-center text-sm">
        <div className="flex flex-col items-center gap-1">
          <div className="flex items-center justify-center mmb:gap-8 smb:gap-7 Iphones:gap-11 Iphones2:gap-10">
            <span className="bg-orange-500 text-white text-xs px-2 py-1  rounded">
              OFERTA
            </span>
            <span className="font-semibold smb:text-xs Iphones2:text-sm">30% OFF em Memórias RAM</span>
            <a
              href="/promocoes/ram"
              className="underline text-white hover:text-orange-200 text-xs"
            >
              Ver ofertas
            </a>            
          </div>

          <div className="text-xs">
            TERMINA EM:{" "}
            <span className="bg-gray-900 px-2 py-1 rounded font-mono">
              {countdown.days}D {formatTime(countdown.hours)}:{formatTime(countdown.minutes)}:{formatTime(countdown.seconds)}
            </span>
          </div>
        </div>
      </div>

      {/* PromoBar Desktop */}
      <div className="hidden sm:block bg-green-600 text-white px-4 py-3">
        <div className="max-w-full mx-auto flex flex-col justify-between items-center text-center sm:flex-row sm:text-left">
          <div className="font-medium flex items-center">
            <span className="bg-orange-500 text-white text-xs px-2 py-1 rounded mr-2">OFERTA</span>
            <span className="mr-2">30% OFF em Memórias RAM</span>
            <a
              href="/promocoes/ram"
              className="text-white underline hover:text-orange-200 transition-colors duration-150"
            >
              Ver ofertas
            </a>
          </div>
          <div className="text-sm flex items-center">
            <span className="mr-2">TERMINA EM:</span>
            <div className="bg-gray-900 px-2 py-1 rounded font-mono">
              {countdown.days}D {formatTime(countdown.hours)}:{formatTime(countdown.minutes)}:{formatTime(countdown.seconds)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromoBar;
